export const rawCid = [
  {
    nm: null,
    nome: 'OUTROS PRODUTOS ANORMAIS DA CONCEPÇÃO',
    codigo: 'O02',
    id_grupo: 'ABORTO',
  },
  { nm: null, nome: 'ABORTO RETIDO', codigo: 'O021', id_grupo: 'ABORTO' },
  { nm: null, nome: 'ABORTO ESPONTÂNEO', codigo: 'O03', id_grupo: 'ABORTO' },
  {
    nm: null,
    nome: 'ABORTO POR RAZÕES MEDICAS E LEGAIS',
    codigo: 'O04',
    id_grupo: 'ABORTO',
  },
  {
    nm: null,
    nome: 'OUTROS TIPOS DE ABORTO',
    codigo: 'O05',
    id_grupo: 'ABORTO',
  },
  {
    nm: null,
    nome: 'ABORTO NÃO ESPECIFICADO',
    codigo: 'O06',
    id_grupo: 'ABORTO',
  },
  { nm: null, nome: 'EXTRAÇÃO MENSTRUAL', codigo: 'Z303', id_grupo: 'ABORTO' },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE',
    codigo: 'E10',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMA',
    codigo: 'E100',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM CETOACIDOSE',
    codigo: 'E101',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES RENAIS',
    codigo: 'E102',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES OFTÁLMICAS',
    codigo: 'E103',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES NEUROLÓGICAS',
    codigo: 'E104',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES CIRCULATÓRIAS PERIFÉRICAS',
    codigo: 'E105',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM OUTRAS COMPLICAÇÕES ESPECIFICADAS',
    codigo: 'E106',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES MÚLTIPLAS',
    codigo: 'E107',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES NÃO ESPECIFICADAS',
    codigo: 'E108',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - SEM COMPLICAÇÕES',
    codigo: 'E109',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE',
    codigo: 'E11',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMA',
    codigo: 'E110',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM CETOACIDOSE',
    codigo: 'E111',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES RENAIS',
    codigo: 'E112',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES OFTÁLMICAS',
    codigo: 'E113',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES NEUROLÓGICAS',
    codigo: 'E114',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES CIRCULATÓRIAS PERIFÉRICAS',
    codigo: 'E115',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM OUTRAS COMPLICAÇÕES ESPECIFICADAS',
    codigo: 'E116',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES MÚLTIPLAS',
    codigo: 'E117',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES NÃO ESPECIFICADAS',
    codigo: 'E118',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - SEM COMPLICAÇÕES',
    codigo: 'E119',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO',
    codigo: 'E14',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMA',
    codigo: 'E140',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM CETOACIDOSE',
    codigo: 'E141',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES RENAIS',
    codigo: 'E142',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES OFTÁLMICAS',
    codigo: 'E143',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES NEUROLÓGICAS',
    codigo: 'E144',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES CIRCULATÓRIAS PERIFÉRICAS',
    codigo: 'E145',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM OUTRAS COMPLICAÇÕES ESPECIFICADAS',
    codigo: 'E146',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES MÚLTIPLAS',
    codigo: 'E147',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES NÃO ESPECIFICADAS',
    codigo: 'E148',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - SEM COMPLICAÇÕES',
    codigo: 'E149',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRE-EXISTENTE COMPLICANDO A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O10',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DISTURBIO HIPERTENSIVO PRE-EXISTENTE COM PROTEINURIA SUPERPOSTA',
    codigo: 'O11',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'EDEMA E PROTEINÚRIA GESTACIONAIS (INDUZIDOS PELA GRAVIDEZ) SEM HIPERTENSÃO',
    codigo: 'O12',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'EDEMA GESTACIONAL', codigo: 'O120', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'PROTEINÚRIA GESTACIONAL',
    codigo: 'O121',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'EDEMA GESTACIONAL COM PROTEINÚRIA',
    codigo: 'O122',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSAO GESTACIONAL (INDUZIDA PELA GRAVIDEZ) SEM PROTEINURIA SIGNIFICATIVA',
    codigo: 'O13',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO GESTACIONAL (INDUZIDA PELA GRAVIDEZ) COM PROTEINÚRIA SIGNIFICATIVA',
    codigo: 'O14',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PRÉ-ECLÂMPSIA MODERADA',
    codigo: 'O140',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PRÉ-ECLÂMPSIA GRAVE',
    codigo: 'O141',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PRÉ-ECLÂMPSIA NÃO ESPECIFICADA',
    codigo: 'O149',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'ECLAMPSIA', codigo: 'O15', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'ECLÂMPSIA NA GRAVIDEZ',
    codigo: 'O150',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ECLÂMPSIA NO TRABALHO DE PARTO',
    codigo: 'O151',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ECLÂMPSIA NÃO ESPECIFICADA QUANTO AO PERÍODO',
    codigo: 'O159',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSAO MATERNA NAO ESPECIFICADA',
    codigo: 'O16',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA DO INÍCIO DA GRAVIDEZ',
    codigo: 'O20',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'AMEAÇA DE ABORTO', codigo: 'O200', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'OUTRAS HEMORRAGIAS DO INÍCIO DA GRAVIDEZ',
    codigo: 'O208',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA DO INÍCIO DA GRAVIDEZ, NÃO ESPECIFICADA',
    codigo: 'O209',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VOMITOS EXCESSIVOS NA GRAVIDEZ',
    codigo: 'O21',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERÊMESE GRAVÍDICA LEVE',
    codigo: 'O210',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERÊMESE GRAVÍDICA COM DISTÚRBIO METABÓLICO',
    codigo: 'O211',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VÔMITOS TARDIOS DA GRAVIDEZ',
    codigo: 'O212',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE VÔMITOS COMPLICANDO A GRAVIDEZ',
    codigo: 'O218',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VÔMITOS DA GRAVIDEZ, NÃO ESPECIFICADOS',
    codigo: 'O219',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NA GRAVIDEZ',
    codigo: 'O22',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VARIZES DOS MEMBROS INFERIORES NA GRAVIDEZ',
    codigo: 'O220',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VARIZES GENITAIS NA GRAVIDEZ',
    codigo: 'O221',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TROMBOFLEBITE SUPERFICIAL NA GRAVIDEZ',
    codigo: 'O222',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FLEBOTROMBOSE PROFUNDA NA GRAVIDEZ',
    codigo: 'O223',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRÓIDAS NA GRAVIDEZ',
    codigo: 'O224',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TROMBOSE VENOSA CEREBRAL NA GRAVIDEZ',
    codigo: 'O225',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES VENOSAS NA GRAVIDEZ',
    codigo: 'O228',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NA GRAVIDEZ, NÃO ESPECIFICADAS',
    codigo: 'O229',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DO TRATO GENITURINÁRIO NA GRAVIDEZ',
    codigo: 'O23',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DO RIM NA GRAVIDEZ',
    codigo: 'O230',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DA BEXIGA NA GRAVIDEZ',
    codigo: 'O231',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DA URETRA NA GRAVIDEZ',
    codigo: 'O232',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DE OUTRAS PARTES DO TRATO URINÁRIO NA GRAVIDEZ',
    codigo: 'O233',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÃO NÃO ESPECIFICADA DO TRATO URINÁRIO NA GRAVIDEZ',
    codigo: 'O234',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DO TRATO GENITAL NA GRAVIDEZ',
    codigo: 'O235',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES E AS NÃO ESPECIFICADAS DO TRATO URINÁRIO NA GRAVIDEZ',
    codigo: 'O239',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NA GRAVIDEZ',
    codigo: 'O24',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, INSULINO-DEPENDENTE',
    codigo: 'O240',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, NÃO-INSULINO-DEPENDENTE',
    codigo: 'O241',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, RELACIONADO COM A DESNUTRIÇÃO',
    codigo: 'O242',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, NÃO ESPECIFICADO',
    codigo: 'O243',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS QUE SURGE DURANTE A GRAVIDEZ',
    codigo: 'O244',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NA GRAVIDEZ, NÃO ESPECIFICADO',
    codigo: 'O249',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DESNUTRICAO NA GRAVIDEZ',
    codigo: 'O25',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES LIGADAS PREDOMINANTEMENTE A GRAVIDEZ',
    codigo: 'O26',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GANHO EXCESSIVO DE PESO NA GRAVIDEZ',
    codigo: 'O260',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GANHO DE PESO INSUFICIENTE NA GRAVIDEZ',
    codigo: 'O261',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'RETENÇÃO DE DISPOSITIVO INTRA-UTERINO CONTRACEPTIVO (DIU) NA GRAVIDEZ',
    codigo: 'O263',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HERPES GESTACIONAL',
    codigo: 'O264',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SÍNDROME DA HIPOTENSÃO MATERNA',
    codigo: 'O265',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES ESPECIFICADAS, LIGADAS A GRAVIDEZ',
    codigo: 'O268',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'AFECÇÕES LIGADAS A GRAVIDEZ, NÃO ESPECIFICADAS',
    codigo: 'O269',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS ANORMAIS DO RASTREAMENTO (SCREENING) ANTENATAL DA MÃE',
    codigo: 'O28',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS HEMATOLÓGICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O280',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS BIOQUÍMICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O281',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS CITOLÓGICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O282',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS ULTRASSONOGRÁFICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O283',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS RADIOLÓGICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O284',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS CROMOSSÔMICOS E GENÉTICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O285',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTROS ACHADOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O288',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE, NÃO ESPECIFICADOS',
    codigo: 'O289',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES DE ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O29',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES PULMONARES DE ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O290',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES CARDÍACAS DE ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O291',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES RELATIVAS AO SISTEMA NERVOSO CENTRAL DEVIDA A ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O292',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'REAÇÃO TÓXICA CAUSADA POR ANESTESIA LOCAL ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O293',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'CEFALÉIA CAUSADA POR ANESTESIA RAQUIDIANA OU PERIDURAL ADMINISTRADAS DURANTE A GRAVIDEZ',
    codigo: 'O294',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DE ANESTESIA RAQUIDIANA OU PERIDURAL ADMINISTRADAS DURANTE A GRAVIDEZ',
    codigo: 'O295',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALHA OU DIFICULDADE NA ENTUBAÇÃO DURANTE A GRAVIDEZ',
    codigo: 'O296',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DE ANESTESIA DURANTE A GRAVIDEZ',
    codigo: 'O298',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES DE ANESTESIA DURANTE A GRAVIDEZ, NÃO ESPECIFICADAS',
    codigo: 'O299',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'GESTAÇÃO MULTIPLA', codigo: 'O30', id_grupo: 'GRAVIDEZ' },
  { nm: null, nome: 'GRAVIDEZ DUPLA', codigo: 'O300', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'GRAVIDEZ TRIGEMELAR',
    codigo: 'O301',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ QUADRIGEMELAR',
    codigo: 'O302',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS GESTAÇÕES MÚLTIPLAS',
    codigo: 'O308',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GESTAÇÃO MÚLTIPLA, NÃO ESPECIFICADA',
    codigo: 'O309',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES ESPECIFICAS DE GESTAÇÃO MULTIPLA',
    codigo: 'O31',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'CONTINUAÇÃO DA GRAVIDEZ APÓS ABORTO DE UM OU MAIS FETOS',
    codigo: 'O311',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'CONTINUAÇÃO DA GRAVIDEZ APÓS A MORTE INTRA-UTERINA DE UM OU MAIS FETOS',
    codigo: 'O312',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES ESPECÍFICAS DE GESTAÇÃO MÚLTIPLA',
    codigo: 'O318',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR MOTIVO DE APRESENTAÇÃO ANORMAL CONHECIDA OU SUSPEITADA DO FETO',
    codigo: 'O32',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR POSIÇÃO FETAL INSTÁVEL',
    codigo: 'O320',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO PÉLVICA',
    codigo: 'O321',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR POSIÇÃO FETAL TRANSVERSA E OBLÍQUA',
    codigo: 'O322',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO DE FACE, MENTO E FRONTE',
    codigo: 'O323',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR POLO CEFÁLICO ALTO EM GESTAÇÃO A TERMO',
    codigo: 'O324',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR GESTAÇÃO MÚLTIPLA COM APRESENTAÇÃO ANORMAL DE UM OU MAIS FETOS',
    codigo: 'O325',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO COMPOSTA',
    codigo: 'O326',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS FORMAS DE APRESENTAÇÃO ANORMAL DO FETO',
    codigo: 'O328',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO ANORMAL DO FETO, NÃO ESPECIFICADA',
    codigo: 'O329',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR UMA DESPROPORÇÃO CONHECIDA OU SUSPEITA',
    codigo: 'O33',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À DEFORMIDADE DA PELVE ÓSSEA MATERNA',
    codigo: 'O330',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À CONTRAÇÃO GERAL DA PELVE',
    codigo: 'O331',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À CONTRAÇÃO DO ESTREITO SUPERIOR DA PELVE',
    codigo: 'O332',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À CONTRAÇÃO DO ESTREITO INFERIOR DA PELVE',
    codigo: 'O333',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DE ORIGEM MISTA, MATERNA E FETAL',
    codigo: 'O334',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA A FETO EXCEPCIONALMENTE GRANDE',
    codigo: 'O335',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA A FETO HIDROCEFÁLICO',
    codigo: 'O336',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA A OUTRAS DEFORMIDADES FETAIS',
    codigo: 'O337',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DE OUTRA ORIGEM',
    codigo: 'O338',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO, NÃO ESPECIFICADA',
    codigo: 'O339',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR ANORMALIDADE CONHECIDA OU SUSPEITA DOS ORGÃOS PÉLVICOS MATERNOS',
    codigo: 'O34',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA À MÃE POR MALFORMAÇÃO CONGÊNITA DO ÚTERO',
    codigo: 'O340',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR TUMOR DO CORPO DO ÚTERO',
    codigo: 'O341',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR CICATRIZ UTERINA DEVIDA A UMA CIRURGIA ANTERIOR',
    codigo: 'O342',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR INCOMPETÊNCIA CERVICAL',
    codigo: 'O343',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES DO COLO DO ÚTERO',
    codigo: 'O344',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES DO ÚTERO GRAVÍDICO',
    codigo: 'O345',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE DA VAGINA',
    codigo: 'O346',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE DA VULVA E DO PERÍNEO',
    codigo: 'O347',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES DOS ÓRGÃOS PÉLVICOS',
    codigo: 'O348',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE DE ÓRGÃOS PÉLVICOS, NÃO ESPECIFICADA',
    codigo: 'O349',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR ANORMALIDADE E LESÃO FETAIS CONHECIDAS OU SUSPEITADAS',
    codigo: 'O35',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR MALFORMAÇÃO DO SISTEMA NERVOSO CENTRAL DO FETO (SUSPEITADA)',
    codigo: 'O350',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE CROMOSSÔMICA (SUSPEITADA) DO FETO',
    codigo: 'O351',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR DOENÇA HEREDITÁRIA (SUSPEITADA) DO FETO',
    codigo: 'O352',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR DOENÇA VIRAL MATERNA',
    codigo: 'O353',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO (SUSPEITADA) CAUSADA AO FETO POR ALCOOLISMO MATERNO',
    codigo: 'O354',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR DROGAS',
    codigo: 'O355',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR RADIAÇÃO',
    codigo: 'O356',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR OUTROS PROCEDIMENTOS MÉDICOS',
    codigo: 'O357',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES OU LESÕES FETAIS (SUSPEITADAS)',
    codigo: 'O358',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO OU ANORMALIDADE FETAIS (SUSPEITADAS), NÃO ESPECIFICADAS',
    codigo: 'O359',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR OUTROS PROBLEMAS FETAIS CONHECIDOS OU SUSPEITADOS',
    codigo: 'O36',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ISOIMUNIZAÇÃO RH',
    codigo: 'O360',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTROS TIPOS DE ISOIMUNIZAÇÃO',
    codigo: 'O361',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR HIDROPSIA FETAL',
    codigo: 'O362',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR SINAIS DE HIPÓXIA FETAL',
    codigo: 'O363',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR INSUFICIÊNCIA DE CRESCIMENTO FETAL',
    codigo: 'O365',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR CRESCIMENTO FETAL EXCESSIVO',
    codigo: 'O366',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR FETO VIÁVEL EM GRAVIDEZ ABDOMINAL',
    codigo: 'O367',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTROS PROBLEMAS FETAIS ESPECIFICADOS',
    codigo: 'O368',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR PROBLEMA FETAL NÃO ESPECIFICADO',
    codigo: 'O369',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'POLI-HIDRAMNIO', codigo: 'O40', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'TRANSTORNOS DAS MEMBRANAS E DO LÍQUIDO AMNIÓTICO',
    codigo: 'O41',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'OLIGOHIDRÂMNIO', codigo: 'O410', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'INFECÇÃO DO SACO AMNIÓTICO E DAS MEMBRANAS',
    codigo: 'O411',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECIFICADOS DO LÍQUIDO AMNIÓTICO E DAS MEMBRANAS',
    codigo: 'O418',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DO LÍQUIDO AMNIÓTICO E DAS MEMBRANAS NÃO ESPECIFICADOS',
    codigo: 'O419',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA PLACENTA',
    codigo: 'O43',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SÍNDROMES DE TRANSFUSÃO PLACENTÁRIA',
    codigo: 'O430',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'MALFORMAÇÃO DA PLACENTA',
    codigo: 'O431',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA PLACENTA',
    codigo: 'O438',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DA PLACENTA, NÃO ESPECIFICADO',
    codigo: 'O439',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'PLACENTA PREVIA', codigo: 'O44', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'PLACENTA PRÉVIA ESPECIFICADA COMO SEM HEMORRAGIA',
    codigo: 'O440',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PLACENTA PRÉVIA COM HEMORRAGIA',
    codigo: 'O441',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA ANTEPARTO NÃO CLASSIFICADA EM OUTRA PARTE',
    codigo: 'O46',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA ANTEPARTO COM DEFICIÊNCIA DE COAGULAÇÃO',
    codigo: 'O460',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRA FORMA DE HEMORRAGIA ANTEPARTO',
    codigo: 'O468',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA ANTEPARTO, NÃO ESPECIFICADA',
    codigo: 'O469',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO',
    codigo: 'O47',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO ANTES DE SE COMPLETAREM 37 SEMANAS DE GESTAÇÃO',
    codigo: 'O470',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO NA 37ª SEMANA COMPLETA OU DEPOIS DELA',
    codigo: 'O471',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO, NÃO ESPECIFICADO',
    codigo: 'O479',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ PROLONGADA',
    codigo: 'O48',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FEBRE DURANTE O TRABALHO DE PARTO NÃO CLASSIFICADA EM OUTRA PARTE',
    codigo: 'O752',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES DURANTE O TRABALHO DE PARTO',
    codigo: 'O753',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇA INFECCIOSA PARASITÁRIA MATERNA COP MAS QUE COMPLIQUEM A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O98',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ANEMIA COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O990',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS DO SANGUE E DOS ÓRGÃOS HEMATOP. E ALGUNS TRANST. QUE COMPROMETEM O SIST. IMUNOLÓGICO',
    codigo: 'O991',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS ENDÓCRINAS, NUTRICIONAIS E METABÓLICAS COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O992',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E DOENÇAS DO SISTEMA NERVOSO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O993',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DO APARELHO CIRCULATÓRIO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O994',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DO APARELHO RESPIRATÓRIO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O995',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DO APARELHO DIGESTIVO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O996',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DA PELE E DO TECIDO SUBCUTÂNEO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O997',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ CONFIRMADA',
    codigo: 'Z321',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ COMO ACHADO CASUAL',
    codigo: 'Z33',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ NORMAL',
    codigo: 'Z34',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE PRIMEIRA GRAVIDEZ NORMAL',
    codigo: 'Z340',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE OUTRA GRAVIDEZ NORMAL',
    codigo: 'Z348',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ NORMAL, NÃO ESPECIFICADA',
    codigo: 'Z349',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ DE ALTO RISCO',
    codigo: 'Z35',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM HISTÓRIA DE ESTERILIDADE',
    codigo: 'Z350',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM HISTÓRIA DE ABORTO',
    codigo: 'Z351',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM OUTROS ANTECEDENTES DE PROCRIAÇÃO PROBLEMÁTICA',
    codigo: 'Z352',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM HISTÓRIA DE ASSISTÊNCIA PRÉ-NATAL INSUFICIENTE',
    codigo: 'Z353',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM GRANDE MULTIPARIDADE',
    codigo: 'Z354',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ DE ALTO RISCO DEVIDO A PROBLEMAS SOCIAIS',
    codigo: 'Z357',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE OUTRAS GRAVIDEZES DE ALTO RISCO',
    codigo: 'Z358',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO NÃO ESPECIFICADA DE GRAVIDEZ DE ALTO RISCO',
    codigo: 'Z359',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'RASTREAMENTO (SCREENING) PRÉ-NATAL',
    codigo: 'Z36',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PROBLEMAS RELACIONADOS COM UMA GRAVIDEZ NÃO DESEJADA',
    codigo: 'Z640',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO ESSENCIAL (PRIMÁRIA)',
    codigo: 'I10',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA',
    codigo: 'I11',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA COM INSUFICIÊNCIA CARDÍACA (CONGESTIVA)',
    codigo: 'I110',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA SEM INSUFICIÊNCIA CARDÍACA (CONGESTIVA)',
    codigo: 'I119',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA',
    codigo: 'I12',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA COM INSUFICIÊNCIA RENAL',
    codigo: 'I120',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA SEM INSUFICIÊNCIA RENAL',
    codigo: 'I129',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA',
    codigo: 'I13',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA COM INSUFICIÊNCIA CARDÍACA (CONGESTIVA)',
    codigo: 'I130',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA COM INSUFICIÊNCIA RENAL',
    codigo: 'I131',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA COM INSUFICIÊNCIA CARDÍACA (CONGESTIVA) E INSUFICIÊNCIA RENAL',
    codigo: 'I132',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA, NÃO ESPECIFICADA',
    codigo: 'I139',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA',
    codigo: 'I15',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO RENOVASCULAR',
    codigo: 'I150',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA A OUTRAS AFECÇÕES RENAIS',
    codigo: 'I151',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA A AFECÇÕES ENDÓCRINAS',
    codigo: 'I152',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE HIPERTENSÃO SECUNDÁRIA',
    codigo: 'I158',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA, NÃO ESPECIFICADA',
    codigo: 'I159',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRE-EXISTENTE COMPLICANDO A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O10',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO ESSENCIAL PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O100',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O101',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O102',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O103',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O104',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRÉ-EXISTENTE NÃO ESPECIFICADA, COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O109',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DISTURBIO HIPERTENSIVO PRE-EXISTENTE COM PROTEINURIA SUPERPOSTA',
    codigo: 'O11',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS ASSOCIADOS AO PUERPÉRIO NÃO CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F53',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS LEVES ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F530',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS GRAVES ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F531',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS MENTAIS E COMPORTAMENTAIS ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F538',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MENTAL E COMPORTAMENTAL ASSOCIADO AO PUERPÉRIO, NÃO ESPECIFICADO',
    codigo: 'F539',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OSTEOMALÁCIA PUERPERAL',
    codigo: 'M830',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRE-EXISTENTE COMPLICANDO A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O10',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO ESSENCIAL PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O100',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O101',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O102',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O103',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O104',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRÉ-EXISTENTE NÃO ESPECIFICADA, COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O109',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ECLÂMPSIA NO PUERPÉRIO',
    codigo: 'O152',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DO FÍGADO NA GRAVIDEZ, NO PARTO E NO PUERPÉRIO',
    codigo: 'O266',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HEMORRAGIAS PÓS-PARTO, TARDIAS E SECUNDÁRIAS',
    codigo: 'O722',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIAS DE COAGULAÇÃO PÓS-PARTO',
    codigo: 'O723',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'INFECCAO PUERPERAL', codigo: 'O85', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES PUERPERAIS',
    codigo: 'O86',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DA INCISÃO CIRÚRGICA DE ORIGEM OBSTÉTRICA',
    codigo: 'O860',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES DOS ÓRGÃOS GENITAIS SUBSEQÜENTES AO PARTO',
    codigo: 'O861',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DAS VIAS URINÁRIAS SUBSEQÜENTES AO PARTO',
    codigo: 'O862',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES DAS VIAS GENITOURINÁRIAS SUBSEQÜENTES AO PARTO',
    codigo: 'O863',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'FEBRE DE ORIGEM DESCONHECIDA SUBSEQÜENTE AO PARTO',
    codigo: 'O864',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES PUERPERAIS ESPECIFICADAS',
    codigo: 'O868',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NO PUERPÉRIO',
    codigo: 'O87',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TROMBOFLEBITE SUPERFICIAL NO PUERPÉRIO',
    codigo: 'O870',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TROMBOFLEBITE PROFUNDA NO PUERPÉRIO',
    codigo: 'O871',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HEMORRÓIDAS NO PUERPÉRIO',
    codigo: 'O872',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TROMBOSE VENOSA CEREBRAL NO PUERPÉRIO',
    codigo: 'O873',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES VENOSAS NO PUERPÉRIO',
    codigo: 'O878',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NO PUERPÉRIO, NÃO ESPECIFICADAS',
    codigo: 'O879',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES DO PUERPÉRIO NÃO CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'O90',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'RUPTURA DA INCISÃO DE CESARIANA',
    codigo: 'O900',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'RUPTURA DA INCISÃO OBSTÉTRICA, NO PERÍNEO',
    codigo: 'O901',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HEMATOMA DA INCISÃO OBSTÉTRICA',
    codigo: 'O902',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'CARDIOMIOPATIA NO PUERPÉRIO',
    codigo: 'O903',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INSUFICIÊNCIA RENAL AGUDA DO PÓS-PARTO',
    codigo: 'O904',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TIREOIDITE DO PÓS-PARTO',
    codigo: 'O905',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DO PUERPÉRIO, NÃO CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'O908',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÃO DO PUERPÉRIO NÃO ESPECIFICADA',
    codigo: 'O909',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÕES MAMÁRIAS ASSOCIADAS AO PARTO',
    codigo: 'O91',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DO MAMILO ASSOCIADA AO PARTO',
    codigo: 'O910',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ABSCESSO DA MAMA ASSOCIADA AO PARTO',
    codigo: 'O911',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'MASTITE NÃO PURULENTA ASSOCIADA AO PARTO',
    codigo: 'O912',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES DA MAMA E DA LACTAÇÃO ASSOCIADAS AO PARTO',
    codigo: 'O92',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'MAMILO RETRAÍDO ASSOCIADO AO PARTO',
    codigo: 'O920',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'FISSURAS DO MAMILO ASSOCIADAS AO PARTO',
    codigo: 'O921',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES DA MAMA, E AS NÃO ESPECIFICADAS, ASSOCIADAS AO PARTO',
    codigo: 'O922',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'AGALACTIA', codigo: 'O923', id_grupo: 'PARTO' },
  { nm: null, nome: 'HIPOGALACTIA', codigo: 'O924', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'SUSPENSÃO DA LACTAÇÃO',
    codigo: 'O925',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'GALACTORRÉIA', codigo: 'O926', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'OUTROS DISTÚRBIOS DA LACTAÇÃO E OS NÃO ESPECIFICADOS',
    codigo: 'O927',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE COMPLICAÇÕES DA GRAVIDEZ, PARTO E PUERPÉRIO',
    codigo: 'O94',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA INFECCIOSA PARASITÁRIA MATERNA COP MAS QUE COMPLIQUEM A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O98',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇAS DA MÃE CLASSIFICADAS EM OUTRA PARTEMAS QUE COMPLICAM A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O99',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS E AFECÇÕES ESPECIFICADAS COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O998',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA E EXAME PÓS-NATAL',
    codigo: 'Z39',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA E EXAME DA MÃE NUTRIZ',
    codigo: 'Z391',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SEGUIMENTO PÓS-PARTO DE ROTINA',
    codigo: 'Z392',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE',
    codigo: 'N80',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO ÚTERO',
    codigo: 'N800',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO OVÁRIO',
    codigo: 'N801',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DA TROMPA DE FALÓPIO',
    codigo: 'N802',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO PERITÔNIO PÉLVICO',
    codigo: 'N803',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO SEPTO RETOVAGINAL E DA VAGINA',
    codigo: 'N804',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO INTESTINO',
    codigo: 'N805',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE EM CICATRIZ CUTÂNEA',
    codigo: 'N806',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRA ENDOMETRIOSE',
    codigo: 'N808',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE NÃO ESPECIFICADA',
    codigo: 'N809',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO AUSENTE ESCASSA E POUCO FREQUENTE',
    codigo: 'N91',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AMENORRÉIA PRIMÁRIA',
    codigo: 'N910',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AMENORRÉIA SECUNDÁRIA',
    codigo: 'N911',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AMENORRÉIA, NÃO ESPECIFICADA',
    codigo: 'N912',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OLIGOMENORRÉIA PRIMÁRIA',
    codigo: 'N913',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OLIGOMENORRÉIA SECUNDÁRIA',
    codigo: 'N914',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OLIGOMENORRÉIA, NÃO ESPECIFICADA',
    codigo: 'N915',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA FREQUENTE E IRREGULAR',
    codigo: 'N92',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA E FREQÜENTE COM CICLO REGULAR',
    codigo: 'N920',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA E FREQÜENTE COM CICLO IRREGULAR',
    codigo: 'N921',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA NA PUBERDADE',
    codigo: 'N922',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO DA OVULAÇÃO',
    codigo: 'N923',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO ABUNDANTE NA PRÉ-MENOPAUSA',
    codigo: 'N924',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS TIPOS ESPECIFICADOS DE IRREGULARIDADE DA MENSTRUAÇÃO',
    codigo: 'N925',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO IRREGULAR, NÃO ESPECIFICADA',
    codigo: 'N926',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS SANGRAMENTOS ANORMAIS DO ÚTERO E DA VAGINA',
    codigo: 'N93',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTOS PÓS-COITO OU DE CONTATO',
    codigo: 'N930',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS SANGRAMENTOS ANORMAIS ESPECIFICADOS DO ÚTERO E DA VAGINA',
    codigo: 'N938',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO ANORMAL DO ÚTERO OU DA VAGINA, NÃO ESPECIFICADO',
    codigo: 'N939',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES ASSOCIADAS COM OS ORGÃOS GENITAIS FEMININOS E COM O CICLO MENSTRUAL',
    codigo: 'N94',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OVULAÇÃO DOLOROSA [MITTELSCHMERZ]',
    codigo: 'N940',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISPAREUNIA',
    codigo: 'N941',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'VAGINISMO',
    codigo: 'N942',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SÍNDROME DE TENSÃO PRÉ-MENSTRUAL',
    codigo: 'N943',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISMENORRÉIA PRIMÁRIA',
    codigo: 'N944',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISMENORRÉIA SECUNDÁRIA',
    codigo: 'N945',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISMENORRÉIA NÃO ESPECIFICADA',
    codigo: 'N946',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES ESPECIFICADAS ASSOCIADAS COM OS ÓRGÃOS GENITAIS FEMININOS E COM O CICLO MENSTRUAL',
    codigo: 'N948',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AFECÇÕES NÃO ESPECIFICADAS ASSOCIADAS COM OS ÓRGÃOS GENITAIS FEMININOS E COM O CICLO MENSTRUAL',
    codigo: 'N949',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA MENOPAUSA E DA PERIMENOPAUSA',
    codigo: 'N95',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO PÓS-MENOPAUSA',
    codigo: 'N950',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ESTADO DA MENOPAUSA E DO CLIMATÉRIO FEMININO',
    codigo: 'N951',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'VAGINITE ATRÓFICA PÓS-MENOPAUSA',
    codigo: 'N952',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONDIÇÕES ASSOCIADAS COM A MENOPAUSA ARTIFICIAL',
    codigo: 'N953',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECIFICADOS DA MENOPAUSA E DA PERIMENOPAUSA',
    codigo: 'N958',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NÃO ESPECIFICADO DA MENOPAUSA E DA PERIMENOPAUSA',
    codigo: 'N959',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTAMENTO HABITUAL',
    codigo: 'N96',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA',
    codigo: 'N97',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA ASSOCIADA À ANOVULAÇÃO',
    codigo: 'N970',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE ORIGEM TUBÁRIA',
    codigo: 'N971',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE ORIGEM UTERINA',
    codigo: 'N972',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE ORIGEM CERVICAL',
    codigo: 'N973',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA ASSOCIADA À FATORES DO PARCEIRO',
    codigo: 'N974',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE OUTRA ORIGEM',
    codigo: 'N978',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA NÃO ESPECIFICADA',
    codigo: 'N979',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTO ESPONTÂNEO',
    codigo: 'O03',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTO POR RAZÕES MEDICAS E LEGAIS',
    codigo: 'O04',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DOR PÉLVICA E PERINEAL',
    codigo: 'R102',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABUSO SEXUAL',
    codigo: 'T742',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - RESIDÊNCIA',
    codigo: 'Y050',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - HABITAÇÃO COLETIVA',
    codigo: 'Y051',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ESCOLAS, OUTRAS INSTIT. E ÁREAS DE ADMINIST. PÚBLICA',
    codigo: 'Y052',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ÁREA PARA A PRÁTICA DE ESPORTES E ATLETISMO',
    codigo: 'Y053',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - RUA E ESTRADA',
    codigo: 'Y054',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ÁREAS DE COMÉRCIO E DE SERVIÇOS',
    codigo: 'Y055',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ÁREAS INDUSTRIAIS E EM CONSTRUÇÃO',
    codigo: 'Y056',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - FAZENDA',
    codigo: 'Y057',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - OUTROS LOCAIS ESPECIFICADOS',
    codigo: 'Y058',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - LOCAL NÃO ESPECIFICADO',
    codigo: 'Y059',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'EXAME ESPECIAL DE RASTREAMENTO DE NEOPLASIA DE MAMA',
    codigo: 'Z123',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'EXAME ESPECIAL DE RASTREAMENTO DE NEOPLASIA DO COLO DO ÚTERO',
    codigo: 'Z124',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTATO COM E EXPOSIÇÃO À HEPATITE VIRAL',
    codigo: 'Z205',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTATO COM E EXPOSIÇÃO AO VÍRUS DA IMUNODEFICIÊNCIA HUMANA [HIV]',
    codigo: 'Z206',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ANTICONCEPÇÃO',
    codigo: 'Z30',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO GERAL SOBRE CONTRACEPÇÃO',
    codigo: 'Z300',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INSERÇÃO DE DISPOSITIVO ANTICONCEPCIONAL (INTRA-UTERINO)',
    codigo: 'Z301',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ESTERILIZAÇÃO',
    codigo: 'Z302',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'EXTRAÇÃO MENSTRUAL',
    codigo: 'Z303',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DO USO DE MEDICAMENTOS ANTICONCEPCIONAIS',
    codigo: 'Z304',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE DISPOSITIVO ANTICONCEPCIONAL (INTRA-UTERINO)',
    codigo: 'Z305',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRO PROCEDIMENTO ANTICONCEPCIONAL',
    codigo: 'Z308',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROCEDIMENTO ANTICONCEPCIONAL NÃO ESPECIFICADO',
    codigo: 'Z309',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDIDAS DE PROCRIAÇÃO',
    codigo: 'Z31',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'TUBOPLASTIA OU VASOPLASTIA APÓS ESTERILIZAÇÃO PRÉVIA',
    codigo: 'Z310',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INSEMINAÇÃO ARTIFICIAL',
    codigo: 'Z311',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'FECUNDAÇÃO IN VITRO',
    codigo: 'Z312',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS MÉTODOS ASSISTIDOS DE FERTILIZAÇÃO',
    codigo: 'Z313',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INVESTIGAÇÃO E TESTES COM RELAÇÃO À PROCRIAÇÃO',
    codigo: 'Z314',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO GENÉTICO',
    codigo: 'Z315',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO GERAL SOBRE A PROCRIAÇÃO',
    codigo: 'Z316',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRA MEDIDA ESPECIFICADA DE PROCRIAÇÃO',
    codigo: 'Z318',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDIDA PROCRIATIVA NÃO ESPECIFICADA',
    codigo: 'Z319',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ (AINDA) NÃO CONFIRMADA',
    codigo: 'Z320',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROBLEMAS DE ADAPTAÇÃO ÀS TRANSIÇÕES DO CICLO DE VIDA',
    codigo: 'Z600',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROBLEMAS NAS RELAÇÕES COM CÔNJUGE OU PARCEIRO',
    codigo: 'Z630',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROBLEMAS RELACIONADOS COM UMA GRAVIDEZ NÃO DESEJADA',
    codigo: 'Z640',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO ÀS ATITUDES, COMPORTAMENTO E ORIENTAÇÃO EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z70',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACOMPANHAMENTO RELATIVO ÀS ATITUDES EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z700',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO AO COMPORTAMENTO E À ORIENTAÇÃO SEXUAL DO SUJEITO',
    codigo: 'Z701',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO AO COMPORTAMENTO E À ORIENTAÇÃO SEXUAL DE UM TERCEIRO',
    codigo: 'Z702',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO A PREOC. RELAC. COM ATITUDES, COMPORT. E ORIENT. EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z703',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS ACONSELHAMENTOS EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z708',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO NÃO ESPECIFICADO EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z709',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO A PROPÓSITO DO VÍRUS DA IMUNODEFICIÊNCIA HUMANA [HIV]',
    codigo: 'Z717',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'COMPORTAMENTO SEXUAL DE ALTO RISCO',
    codigo: 'Z725',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
]
